module.exports = __webpack_public_path__ + "static/media/arch.3f2183c2.png";